export default class PlatformSettings {

    private _data: any;

    constructor(data: any) {
        this._data = data;
    }

    getBetSet() {
        return this._data.bet_set;
    }

    getBet() {
        return this._data.bet;
    }

    getBonusBet() {
        return this._data.bonus_bet;
    }

    getMaxBet() {
        return this._data.max_bet;
    }

    getMaxLineBet() {
        return this._data.max_line_bet;
    }

    getMinBet() {
        return this._data.min_bet;
    }

    getMinLineBet() {
        return this._data.min_line_bet;
    }

    getAutostart() {
        return this._data.auto_start;
    }
}